var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 7.502,
  height: 9.342,
  viewBox: "0 0 7.502 9.342"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-angle-double-down",
  "data-name": "Icon awesome-angle-double-down",
  d: "M3.352,6.007.164,2.82a.56.56,0,0,1,0-.795l.53-.53a.56.56,0,0,1,.795,0L3.748,3.755,6.007,1.5a.56.56,0,0,1,.795,0l.534.527a.56.56,0,0,1,0,.795L4.148,6a.561.561,0,0,1-.8,0Zm.8,4.5L7.336,7.32a.56.56,0,0,0,0-.795L6.806,6a.56.56,0,0,0-.795,0L3.75,8.252,1.491,5.993a.56.56,0,0,0-.795,0l-.532.53a.56.56,0,0,0,0,.795L3.352,10.5a.561.561,0,0,0,.8,0Z",
  transform: "translate(0.001 -1.33)",
  fill: "#898989"
})));
export default __webpack_public_path__ + "static/media/RestockingDownArrows.d8e70e6c.svg";
export { SvgComponent as ReactComponent };